import { useContext } from 'react';
import { ToolsContext, ToolsContextType } from 'Contexts';

export const useToolsContext = (): ToolsContextType => {
  const context = useContext(ToolsContext);

  return context;
};
